import {ApplicationRef, Injectable} from '@angular/core';
import {RequirementTypesList} from "../interfaces/requirement-types-list";
import {JobRequirement} from "../interfaces/job-requirement";
import {BehaviorSubject} from "rxjs";
import {RequirementType} from "../interfaces/requirement-type";

@Injectable({
  providedIn: 'root'
})
export class JobRequirementsService {

  requirementsSet = false;
  onRequirementsUpdated = new BehaviorSubject(this.requirementsSet);

  // Map of type JobRequirement to store all requirements
  requirementsMap: Map<string, JobRequirement> = new Map();

  jobRequirements: RequirementTypesList = {
    physicalRequirements: {
      selfAssessmentSlide: 1,
      bicId: 1,
      name: 'Körperliche Anforderungen',
      jobsFilterStateKey: 'physicalSkills',
      requirements: []
    },
    expertiseRequirements: {
      selfAssessmentSlide: 2,
      bicId: 2,
      name: 'Fachliche Anforderungen',
      jobsFilterStateKey: 'hardSkills',
      requirements: []
    },
    socialRequirements: {
      selfAssessmentSlide: 3,
      bicId: 3,
      name: 'Soziale Anforderungen',
      jobsFilterStateKey: 'socialSkills',
      requirements: []
    },
    selfRequirements: {
      selfAssessmentSlide: 4,
      bicId: 4,
      name: 'Persönliche Anforderungen',
      jobsFilterStateKey: 'selfSkills',
      requirements: []
    },
    methodologicalRequirements: {
      selfAssessmentSlide: 5,
      bicId: 6,
      name: 'Methodische Anforderungen',
      jobsFilterStateKey: 'methodSkills',
      requirements: []
    }
  };

  blackListedRequirements: JobRequirement[] = [];

  constructor(
    private ref: ApplicationRef
  ) { }

  blacklistedRequirementBicIds = [
    341,
    112,
    124,
    353,
    105,
    101,
    116,
    38,
    286,
    316,
    73,
    18,
    281,
    319,
    232,
    14,
    337,
    296,
    219,
    40
  ];

  setAllRequirementsFromApi(response: any): RequirementTypesList {

      if(response && ! this.requirementsSet) {
        response.requirementTypes.forEach((item: any) => {

          item.requirements.forEach((requirement: any) => {

            if(this.blacklistedRequirementBicIds.indexOf(requirement.bicID) > -1) {
              this.blackListedRequirements.push(this.parseRequirement(requirement));
              return;
            }

            this.requirementsMap.set(requirement.bicID.toString(), this.parseRequirement(requirement));

            switch (item.requirementType.bicID) {
              case 1:
                this.jobRequirements.physicalRequirements.requirements.push(this.parseRequirement(requirement));
                break;
              case 2:
                this.jobRequirements.expertiseRequirements.requirements.push(this.parseRequirement(requirement));
                break;
              case 3:
                this.jobRequirements.socialRequirements.requirements.push(this.parseRequirement(requirement));
                break;
              case 4:
                this.jobRequirements.selfRequirements.requirements.push(this.parseRequirement(requirement));
                break;
              // case 5:
                // this.jobRequirements.furtherRequirements.requirements.push(this.parseRequirement(requirement));
                // break;
              case 6:
                this.jobRequirements.methodologicalRequirements.requirements.push(this.parseRequirement(requirement));
                break;
            }
          });

        });

        this.requirementsSet = true;
        this.onRequirementsUpdated.next(this.requirementsSet);

      }

      this.ref.tick();

      return this.jobRequirements;

  }

  parseRequirement(rawRequirement: any): JobRequirement {
    return {
      id: parseInt(rawRequirement.bicID),
      bicID: parseInt(rawRequirement.bicID),
      requirementName: rawRequirement.requirementName,
      description: rawRequirement.description
    }
  }

  getAllRequirements() {
    return this.jobRequirements;
  }

  getRequirementById(id: number) {
    return this.requirementsMap.get(id.toString());
  }

  getRequirementNameById(id: number) {

    const requirement = this.requirementsMap.get(id.toString());

    if (requirement) {
      return requirement.requirementName;
    }

    const blackListedRequirement = this.blackListedRequirements.filter((el) => el.id === id);
    if(blackListedRequirement.length) {
      return blackListedRequirement[0].requirementName;
    }

    return '';
  }

  getRequirementsGroupByType(type: string) {
    // Check if Object has key
    if (!this.jobRequirements.hasOwnProperty(type)) {
      return new Array(0);
    }

    // @ts-ignore
    return this.jobRequirements[type];
  }

}
